export const GROWTH_MARKET_META = {
  eyebrow: 'Google Ads & SEO',
  titleLead: 'Market',
  titleAccent: 'intelligence',
  description:
    'Everything ELVA knows about your local market. This intelligence drives your Ad Autopilot and SEO strategy decisions.',
  footerNote: 'Aggregated from 8 competitors · 1,847 data points · updated every 24 hours',
} as const;
